export const API_ENDPOINTS = {
  APPLICATION_DETAILS: (applicationId: string | number) =>
    `/ats_applications/${applicationId}`,
  APPLICATION_NOTES: (applicationId: string | number) =>
    `/ats_applications/${applicationId}/notes`,
  REJECTION_REASONS: '/ats_rejection_reasons',
  ENTITY_VIEWS: 'entity_views',

  CONTACT_DETAILS: (contactId: string | number) => `/contacts/${contactId}`,

  SEARCH_APPLICATIONS: (jobId: string | number) =>
    `ats_jobs/${jobId}/search/ats_applications/`,
  AUTOCOMPLETE_TAGS:
    '/search/circles/autocomplete_tags?filter_name=tags&filter_value=',
} as const;

export const CONFIG = {
  STALE_TIME: {
    DEFAULT: 5 * 60 * 1000,
    REJECTION_REASONS: 10 * 60 * 1000,
  },
  GC_TIME: 30 * 60 * 1000,

  NOTES: {
    DEFAULT_PAGE: 1,
    DEFAULT_ITEMS: 5,
  },

  PREFETCH: {
    INITIAL_COUNT: 10,
    NEXT_BATCH_AT_INDEX: 5,
  },

  PAYLOAD: {
    STATUS: 'active',
    QUICK_REVIEW: true,
    VIEWABLE_TYPE: 'AtsApplication',
    PAGE_SORT_VALUE: 'page_sort',
  },
} as const;

export const UI = {
  MODAL: {
    HEIGHT: '90vh',
    MAX_HEIGHT: '90vh',
    MIN_WIDTH: '1200px',
  },

  NAVIGATION: {
    BUTTON_SIZE: '48px',
    BUTTON_OFFSET: '-70px',
    ICON_SIZE: '20px',
  },

  ICON: {
    SMALL: '16px',
    MEDIUM: '20px',
  },

  EDITOR: {
    NOTES_HEIGHT: '120px',
  },

  CONTENT_LOADER: {
    BACKGROUND: '#3d3d5c',
    FOREGROUND: '#4d4d6d',
  },
} as const;

export const MIME_TYPES = {
  MS_WORD: 'application/msword',
  MS_WORD_X:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  OLE_STORAGE: 'application/x-ole-storage',
  PDF: 'application/pdf',
} as const;

export const RESUME_PREVIEW = {
  SUPPORTED_TYPES: [
    MIME_TYPES.MS_WORD,
    MIME_TYPES.MS_WORD_X,
    MIME_TYPES.OLE_STORAGE,
  ],
} as const;
